import { useTranslations as useIntlTranslations } from 'next-intl';

export const useTranslations = useIntlTranslations;

export type TranslatePrefix = Parameters<typeof useTranslations>[0];
